import { render, staticRenderFns } from "./casitem.vue?vue&type=template&id=547563c9"
import script from "./casitem.vue?vue&type=script&lang=js"
export * from "./casitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports